import React from 'react'
import "../styles/intro.css";

function Intro() {
  return (
    <div className="intro_box">
        <div className='text_box'>
        <h1 className='intro_heading'>Weather Forecast <br /> Application</h1>
        <p>join us to get the best eperience of weather telecast around you and farther away....</p>
        </div>
    </div>
  )
}

export default Intro